import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useHistory } from "react-router-dom";
import { useMediaQuery, Box, Button } from "@material-ui/core";

import Grid from "../components/Grid";
import Table from "../components/Table";
import { CardContent } from "../components/Card";
import Text from "../components/Text";
import moment from "moment";

export default function PrintForeclosures() {
  const history = useHistory();

  function getPatterns(obj_type, obj_patterns) {
    switch (obj_type) {
      case "L":
        return obj_patterns !== "" ? obj_patterns : "土地";
      case "H":
        return obj_patterns !== "" ? obj_patterns : "建物";
      default:
        return "";
    }
  }

  function getCaseName(obj_str, obj_share, obj_caseno, obj_another) {
    const share = Array.from(obj_share);
    const condition = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    let sourcefnp = false;
    if (share.indexOf("台") > -1 && share.indexOf("金") > -1) {
      sourcefnp = true;
    } else {
      share.forEach((item) => {
        condition.map((item2) => {
          if (item.indexOf(item2) > -1) sourcefnp = true;
        });
      });
    }

    return sourcefnp
      ? obj_str +
          "批號" +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n"
      : obj_str +
          obj_share +
          obj_caseno +
          (!!obj_another &&
          obj_another.indexOf("(") === -1 &&
          obj_another.indexOf("-") === -1
            ? "(" + obj_another + ")"
            : obj_another) +
          "\n";
  }

  function print_action() {
    var restorepage = document.body.innerHTML;
    var printcontent = document.getElementById("printable").innerHTML;
    document.body.innerHTML = printcontent;
    window.print();
    document.body.innerHTML = restorepage;
    window.location.reload();
  }

  return (
    <>
      <Grid container style={{ margin: "8px" }}>
        <Grid item>
          <Button variant="contained" color="primary" onClick={print_action}>
            列印
          </Button>
        </Grid>
      </Grid>
      <Box id="printable">
        <CardContent style={{ padding: 0 }}>
          <Table
            data={
              JSON.parse(localStorage.getItem("@printData"))
                ? JSON.parse(localStorage.getItem("@printData"))
                : []
            }
            tableWidth={1}
            columnWidths={[100, 180, 100, 80, 70, 105, 100, 70]}
            header={[
              "案號\n債務人",
              "大樓案名\n門牌地址",
              "日期\n時間",
              "類別\n狀況",
              "建坪\n地坪",
              "建坪／萬\n地坪／萬",
              "拍賣底價\n保證金",
              "拍次\n點交",
            ]}
            columns={[
              (item) => (
                <>
                  <Text color="#22b169">
                    {getCaseName(
                      item.obj_str,
                      item.obj_share,
                      item.obj_caseno,
                      item.obj_another
                    )}
                  </Text>
                  <Text>{item.obj_debtor.substr(0, 1) + "**"}</Text>
                </>
              ),
              (item) => (
                <Grid container justifyContent="center">
                  <Grid item>
                    <Text color="#22b169">
                      {item.obj_city + item.obj_area + "\n"}
                    </Text>
                    {item.obj_type === "H" ? (
                      <Text>
                        {item.obj_city + item.obj_area + item.obj_address}
                      </Text>
                    ) : (
                      <Text>
                        {item.obj_city +
                          item.obj_area +
                          item.obj_section +
                          "段" +
                          item.obj_section_s +
                          (item.obj_section_s ? "小段" : "") +
                          item.obj_landno +
                          (item.obj_landno ? "地號" : "")}
                      </Text>
                    )}
                  </Grid>
                </Grid>
              ),
              (item) => (
                <>
                  <Text color="#22b169">
                    {moment(item.obj_date_ymd).format("YYYY/MM/DD") + "\n"}
                  </Text>
                  {history.location.state?.newData.respondBuy === "during" && (
                    <Text>{"到\n"}</Text>
                  )}
                  <Text>
                    {history.location.state?.newData.respondBuy === "during"
                      ? moment(item.obj_date_ymd)
                          .add(3, "months")
                          .format("YYYY-MM-DD")
                      : moment(item.obj_date_hi).format("HH:mm")}
                  </Text>
                  {item.obj_price_set !== 0 && (
                    <>
                      <Text
                        style={{ backgroundColor: "#ff9800" }}
                      >{`\n拍定價:${(item.obj_price_set / 10000).toFixed(
                        2
                      )}萬\n`}</Text>
                      <Text style={{ backgroundColor: "#ff9800" }}>{`每坪價:${
                        item.obj_type === "H"
                          ? (item.obj_price / item.obj_total_floor).toFixed(2) +
                            "萬"
                          : (item.obj_price / item.obj_land_floor).toFixed(2) +
                            "萬"
                      }`}</Text>
                    </>
                  )}
                </>
              ),
              (item) => (
                <>
                  <Text>
                    {getPatterns(item.obj_type, item.obj_patterns) + "\n"}
                  </Text>
                  {item.obj_stop !== "" && (
                    <Button variant="contained" color="primary">
                      停拍公告
                    </Button>
                  )}
                </>
              ),
              (item) => (
                <>
                  <Text color="#22b169">{item.obj_total_floor + "\n"}</Text>
                  <Text>{item.obj_land_floor}</Text>
                </>
              ),
              (item) => (
                <>
                  <Text color="#22b169">
                    {item.obj_total_floor === 0
                      ? 0 + "\n"
                      : (item.obj_price / item.obj_total_floor).toFixed(2) +
                        "萬" +
                        "\n"}
                  </Text>
                  <Text>
                    {item.obj_land_floor === 0
                      ? 0
                      : (item.obj_price / item.obj_land_floor).toFixed(2) +
                        "萬"}
                  </Text>
                </>
              ),
              (item) => (
                <>
                  <Text color="#22b169">{item.obj_price + "萬" + "\n"}</Text>
                  <Text>{(item.obj_margin / 10000).toFixed(2) + "萬"}</Text>
                </>
              ),
              (item) => (
                <>
                  <Text color="#22b169">
                    {`${item.obj_time === "0" ? "應買" : item.obj_time}` + "\n"}
                  </Text>
                  <Text>
                    {(() => {
                      switch (item.obj_transfer) {
                        case "0":
                          return "不點交";
                        case "1":
                          return "點交";
                        case "2":
                          return "依公文判斷";
                        default:
                          break;
                      }
                    })()}
                  </Text>
                </>
              ),
            ]}
          />
        </CardContent>
      </Box>
    </>
  );
}
